import {
  AfterViewInit,
  ChangeDetectionStrategy,
  Component,
  ElementRef,
  EventEmitter,
  Input,
  Output,
  ViewChild
} from '@angular/core';
import {PortVisitCommonModule} from "../../../../../common/port-visit-common.module";
import {Handler} from "../../../../../common/handlers/handler";
import {View} from "../../../../../common/handlers/view";
import {NgClass} from "@angular/common";
import {Observable} from "rxjs";
import {FormsModule} from "@angular/forms";

@Component({
  selector: 'app-facet-filter-search-field',
  imports: [
    PortVisitCommonModule,
    NgClass,
    FormsModule
  ],
  templateUrl: './facet-filter-search-field.component.html',
  changeDetection: ChangeDetectionStrategy.Eager,
  styleUrl: './facet-filter-search-field.component.scss',
})
@Handler()
export class FacetFilterSearchFieldComponent extends View implements AfterViewInit {
  protected term: any;

  @Input() value: any;
  @Input() filterName: string;
  @Input() dataKey: string;
  @Input() searchFunction: (arg: string) => Observable<any[]>;
  @Input() inputFormatter : (value : any) => string;
  @Input() selectedValueFormatter: (v: any) => string;
  @Input() minCharacters: number = 0;

  protected results: any[];

  @Output() valueSelected: EventEmitter<any> = new EventEmitter<any>();

  @ViewChild("dropdown") dropdown: ElementRef;
  @ViewChild("button") button: ElementRef;

  ngAfterViewInit(): void {
    $(this.dropdown.nativeElement).on("show.bs.dropdown", () => {
      this.button.nativeElement.classList.add("active");
      return true;
    });
    $(this.dropdown.nativeElement).on("hide.bs.dropdown", () => {
      this.button.nativeElement.classList.remove("active");
      this.term = null;
      return true;
    });
  }

  get hasValue() {
    return !!this.value;
  }

  protected removeFilter = () => this.selectValue(null);

  protected selectValue(value: any) {
    this.value = value;
    this.valueSelected.emit(this.value);
  }
}
